/**
 * A MyGeotab `Get` call answers with a list of entities, but the IAM login code reads fields (such as
 * `userAuthenticationType`) straight off "the user". Reading them off the list is always `undefined`, which silently
 * disables the service-account check. This returns the first entity; an object is passed through untouched and an
 * empty list stays `undefined`, so a lookup that finds nothing does not start failing logins that pass today.
 */
export function unwrapFirstUser<T>(result: T | T[] | null | undefined): T | undefined {
    return (Array.isArray(result) ? result[0] : result) ?? undefined;
}
